import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArchivedCompaniesRoutingModule } from './archived-companies-routing.module';
import { NavbarModule } from '../navbar/navbar.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingModule } from '../loading/loading.module';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableModule } from '@angular/material/table';

import { ArchivedCompaniesComponent } from './archived-companies/archived-companies.component';
import { ArchivedCompaniesHeaderComponent } from './archived-companies-header/archived-companies-header.component';
import { ArchivedCompaniesDataComponent } from './archived-companies-data/archived-companies-data.component';
import { ArchivedCompaniesDataEmptyComponent } from './archived-companies-data-empty/archived-companies-data-empty.component';
import { ArchivedCompaniesDataTableComponent } from './archived-companies-data-table/archived-companies-data-table.component';
import { ArchivedCompaniesNoteDialogComponent } from './archived-companies-note-dialog/archived-companies-note-dialog.component';
import { ArchivedCompaniesFiltersComponent } from './archived-companies-filters/archived-companies-filters.component';
import { ArchivedCompaniesFilterDialogComponent } from './archived-companies-filter-dialog/archived-companies-filter-dialog.component';

@NgModule({
  declarations: [
    ArchivedCompaniesComponent,
    ArchivedCompaniesHeaderComponent,
    ArchivedCompaniesDataComponent,
    ArchivedCompaniesDataEmptyComponent,
    ArchivedCompaniesDataTableComponent,
    ArchivedCompaniesNoteDialogComponent,
    ArchivedCompaniesFiltersComponent,
    ArchivedCompaniesFilterDialogComponent,
  ],
  imports: [
    CommonModule,
    ArchivedCompaniesRoutingModule,
    NavbarModule,
    ToolbarModule,
    TranslateModule,
    LoadingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatTableModule,
  ],
})
export class ArchivedCompaniesModule {}
